/**
 * The unscheduled pill and its Smart Filters chip are read side by side, so a
 * drift between their slates shows.
 */
const SLATE = {
  text: "#64748B",
  fill: "#F1F5F9",
  border: "#CBD5E1"
} as const

export { SLATE }
